import { useState, useEffect } from "react";
import { Outlet, Link, useLoaderData, NavLink } from "react-router-dom";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import es from "react-phone-input-2/lang/es.json";

import { TratamientoAdminList } from "./TratamientoAdminList";

import * as API from "../services/pacientes";

import * as APILOG from "../services/gananciaslog";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getPacienteByID(params.pacienteId);
}

export function PacienteAdminItem() {
  const paciente = useLoaderData();

  const [isCreatingButton, setIsCreatingButton] = useState(false);

  const firstName = paciente?.first_name;
  const lastName = paciente?.last_name;
  const sexoPacie = paciente?.meta?.sexo_paciente;
  const direccion = paciente?.meta?.direccion;
  const direccionNum = paciente?.meta?.direccion_num;
  const direccionPiso = paciente?.meta?.direccion_piso;
  const direccionCiudad = paciente?.meta?.direccion_ciudad;
  const direccionProvincia = paciente?.meta?.direccion_provincia;
  const direccionCp = paciente?.meta?.direccion_cp;
  const email = paciente?.email;
  const telefono = paciente?.meta?.telefono;
  const dni = paciente?.meta?.dni;
  const nacimiento = paciente?.meta?.nacimiento;
  const username = paciente?.username;
  const metaTratamiento = paciente.meta?.tratamientos;
  const hce = paciente.meta?.hce;
  const nombreFamiliar = paciente?.meta?.nombre_familiar;
  const telefonoFamiliar = paciente?.meta?.telefono_familiar;
  const estadoUsuario = paciente?.meta?.estado || "activo";

  const formatCurrency = (amount) => {
    if (isNaN(amount)) return "€0.00";
    return `€${parseFloat(amount).toFixed(2)}`;
  };

  const [gananciasLogs, setGananciasLogs] = useState([]);

  const credito = formatCurrency(paciente?.meta?.credito);

  useEffect(() => {
    APILOG.getGananciasLog(paciente.id)
      .then(setGananciasLogs)
      .catch(console.log);
  }, [paciente]);

  let tratamientoList;
  if (metaTratamiento && metaTratamiento?.length !== 0) {
    tratamientoList = <TratamientoAdminList list={metaTratamiento} />;
  } else {
    tratamientoList = <div className="treatment-list">Sin tratamientos</div>;
  }

  const handlePasswordResetRequest = (e) => {
    e.preventDefault();
    setIsCreatingButton(true);

    API.sendResetPasswordEmail(paciente.id)
      .then((response) => {
        alert(response);
      })
      .catch((err) => {
        console.log("Error en la solicitud de restablecimiento:", err);
        alert("No se pudo enviar el correo de restablecimiento.");
      })
      .finally(() => {
        setIsCreatingButton(false);
      });
  };

  return (
    <>
      <div id="content">
        <form id="formNewElement">
          <fieldset id="disabledContainer" disabled="disabled">
            <h3>Ficha del Paciente</h3>
            <div className="grid--2col">
              <div className="field">
                <label htmlFor="firstName">Nombre</label>
                <div className="control">
                  <input
                    className="input"
                    id="firstName"
                    readOnly
                    type="text"
                    value={firstName}
                  />
                </div>
              </div>
              <div className="field">
                <label htmlFor="lastName">Apellidos</label>
                <div className="control">
                  <input
                    className="input"
                    id="lastName"
                    readOnly
                    type="text"
                    value={lastName}
                  />
                </div>
              </div>
            </div>

            <div className="grid--2col">
              <div className="field">
                <label htmlFor="sexoPacie">Sexo</label>
                <div className="control">
                  <div className="select">
                    <select
                      className="select"
                      id="sexoPacie"
                      required
                      name="sexoPacie"
                      value={sexoPacie}
                    >
                      <option disabled value="">
                        -- Selecciona una opción --
                      </option>
                      <option value="hombre">Hombre</option>
                      <option value="mujer">Mujer</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="field">
                <label htmlFor="direccion">Dirección</label>
                <div className="control">
                  <input
                    className="input"
                    id="direccion"
                    readOnly
                    type="text"
                    value={direccion}
                  />
                </div>
              </div>
              <div className="field">
                <label htmlFor="direccionNum">Número</label>
                <div className="control">
                  <input
                    className="input"
                    id="direccionNum"
                    readOnly
                    type="text"
                    value={direccionNum}
                  />
                </div>
              </div>
              <div className="field">
                <label htmlFor="direccionPiso">Piso</label>
                <div className="control">
                  <input
                    className="input"
                    id="direccionPiso"
                    readOnly
                    type="text"
                    value={direccionPiso}
                  />
                </div>
              </div>

              <div className="field">
                <label htmlFor="direccionCiudad">Población</label>
                <div className="control">
                  <input
                    className="input"
                    id="direccionCiudad"
                    readOnly
                    type="text"
                    value={direccionCiudad}
                  />
                </div>
              </div>
              <div className="field">
                <label htmlFor="direccionProvincia">Provincia</label>
                <div className="control">
                  <input
                    className="input"
                    id="direccionProvincia"
                    readOnly
                    type="text"
                    value={direccionProvincia}
                  />
                </div>
              </div>
              <div className="field">
                <label htmlFor="direccionCp">Código postal</label>
                <div className="control">
                  <input
                    className="input"
                    id="direccionCp"
                    readOnly
                    type="text"
                    value={direccionCp}
                  />
                </div>
              </div>
            </div>

            <div className="grid--2col">
              <div className="field">
                <label htmlFor="email">Email</label>
                <div className="control">
                  <input
                    className="input"
                    id="email"
                    readOnly
                    type="email"
                    value={email}
                  />
                </div>
              </div>
              <div className="field">
                <label htmlFor="telefono">Teléfono Móvil</label>
                <div className="control">
                  <PhoneInput
                    inputProps={{
                      className: "input",
                      name: "telefono",
                      required: true,
                      id: "telefono",
                      readOnly: true,
                    }}
                    disabled
                    placeholder="+34 658 309 174"
                    localization={es}
                    value={telefono}
                    country={"es"}
                  />
                </div>
              </div>
            </div>

            <div className="grid--2col">
              <div className="field">
                <label htmlFor="dni">NIF/Pasaporte</label>
                <div className="control">
                  <input
                    className="input"
                    id="dni"
                    readOnly
                    type="text"
                    value={dni}
                  />
                </div>
              </div>
              <div className="field">
                <label htmlFor="nacimiento">Fecha de Nacimiento</label>
                <div className="control">
                  <input
                    className="input"
                    id="nacimiento"
                    readOnly
                    type="date"
                    value={nacimiento}
                  />
                </div>
              </div>
            </div>

            {/* <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='username'>Nombre de usuario</label>
              <div className='control'>
                <input
                  className='input'
                  id='username'
                  readOnly
                  type='text'
                  value={username}
                />
              </div>
            </div>
          </div> */}

            <div className="grid--2col">
              <div className="field">
                <label htmlFor="hce">NHC</label>
                <div className="control">
                  <input
                    className="input"
                    id="hce"
                    required
                    type="number"
                    value={hce}
                    readOnly
                  />
                </div>
              </div>
            </div>

            <div className="grid--2col">
              <div className="field">
                <label htmlFor="nombreFamiliar">Nombre de familiar</label>
                <div className="control">
                  <input
                    className="input"
                    id="nombreFamiliar"
                    readOnly
                    type="text"
                    value={nombreFamiliar}
                  />
                </div>
              </div>
              <div className="field">
                <label htmlFor="telefonoFamiliar">
                  Número de teléfono de familiar
                </label>
                <div className="control">
                  <PhoneInput
                    inputProps={{
                      className: "input",
                      name: "telefonoFamiliar",
                      required: true,
                      id: "telefonoFamiliar",
                      readOnly: true,
                    }}
                    disabled
                    placeholder="+34 658 309 174"
                    localization={es}
                    value={telefonoFamiliar}
                    country={"es"}
                  />
                </div>
              </div>
            </div>

            <div className="grid--2col">
              <div className="field">
                <label htmlFor="estadoUsuario">Estado del usuario</label>
                <div className="control">
                  <div className="select">
                    <select
                      className="select"
                      id="estadoUsuario"
                      readOnly
                      name="estadoUsuario"
                      value={estadoUsuario}
                    >
                      <option disabled value="">
                        -- Selecciona una opción --
                      </option>
                      <option value="activo">Activo</option>
                      <option value="inactivo">Inactivo</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="field">
                <label htmlFor="cantidadAcumulada">Cantidad acumulada</label>
                <div className="control">
                  <input
                    className="input"
                    id="cantidadAcumulada"
                    readOnly
                    type="text"
                    value={credito}
                  />
                </div>
              </div>
            </div>
          </fieldset>
        </form>
        <div>
          <h3>Reenviar datos de acceso</h3>
          <button
            id="resetPassword"
            className="button is-link"
            onClick={handlePasswordResetRequest}
            disabled={isCreatingButton}
          >
            {isCreatingButton ? <div className="spinner"></div> : "Reenviar"}
          </button>
        </div>
        <br></br>
        <div className="mb-5">
          <h3 className="label-title">Listado de tratamientos:</h3>
          {tratamientoList}
          <Link className="button is-link" to={`tratamientos/new`}>
            Nuevo
          </Link>
        </div>
        <div className="mb-5">
          <h3 className="label-title">Ganancias:</h3>
          <p className="is-uppercase mb-4">Total acumulado: {credito}</p>
          <p className="is-uppercase">Historial:</p>
          {gananciasLogs.length > 0 ? (
            gananciasLogs.map((item) => (
              <p key={item.id}>
                - {item.fecha_publicacion}: {item.meta?.logText}
              </p>
            ))
          ) : (
            <p>No hay registros de ganancias.</p>
          )}
        </div>
      </div>
      <div id="actions">
        <Link className="button is-link" to={`edit`}>
          Editar
        </Link>
      </div>
    </>
  );
}
